import { Form, FormInstance, InputRef } from 'antd';
import { get, set } from 'lodash';
import styled, { css } from 'styled-components';
import one_hundred_dollar_icon from './icons/100_dollar.png';
import ten_cent_icon from './icons/10_cent.png';
import ten_dollar_icon from './icons/10_dollar.png';
import one_cent_icon from './icons/1_cent.png';
import one_dollar_icon from './icons/1_dollar.png';
import twenty_dollar_icon from './icons/20_dollar.png';
import twenty_five_cent_icon from './icons/25_cent.png';
import two_dollar_icon from './icons/2_dollar.png';
import fifty_dollar_icon from './icons/50_dollar.png';
import five_dollar_icon from './icons/5_dollar.png';
// import  from '../../payments/MultiPayment/ModalMultiplePayments/PassValueForm';
import PassValueForm from 'components/PassValueForm';
import { ICashDepositItem } from 'features/cashier/components/CashDeposit/types';
import { formatCurrency } from 'utils/formatCurrency';
import CashierInputNumber from './InputNumber';
import Text from 'components/Text';

export enum CASH_DEPOSIT_CASH_TYPE {
  ONE_CENT = 'ONE_CENT',
  TEN_CENT = 'TEN_CENT',
  TWENTY_FIVE_CENT = 'TWENTY_FIVE_CENT',
  ONE_DOLLAR = 'ONE_DOLLAR',
  TWO_DOLLAR = 'TWO_DOLLAR',
  FIVE_DOLLAR = 'FIVE_DOLLAR',
  TEN_DOLLAR = 'TEN_DOLLAR',
  TWENTY_DOLLAR = 'TWENTY_DOLLAR',
  FIFTY_DOLLAR = 'FIFTY_DOLLAR',
  ONE_HUNDRED = 'ONE_HUNDRED',
}

const configs = {
  [CASH_DEPOSIT_CASH_TYPE.ONE_CENT]: {
    label: '1 cent',
    icon: one_cent_icon,
    value: 0.01,
  },
  [CASH_DEPOSIT_CASH_TYPE.TEN_CENT]: {
    label: '10 cent',
    icon: ten_cent_icon,
    value: 0.1,
  },
  [CASH_DEPOSIT_CASH_TYPE.TWENTY_FIVE_CENT]: {
    label: '25 cent',
    icon: twenty_five_cent_icon,
    value: 0.25,
  },
  [CASH_DEPOSIT_CASH_TYPE.ONE_DOLLAR]: {
    label: '$1 BILLs',
    icon: one_dollar_icon,
    value: 1,
  },
  [CASH_DEPOSIT_CASH_TYPE.TWO_DOLLAR]: {
    label: '$2 bills',
    icon: two_dollar_icon,
    value: 2,
  },
  [CASH_DEPOSIT_CASH_TYPE.FIVE_DOLLAR]: {
    label: '$5 bills',
    icon: five_dollar_icon,
    value: 5,
  },
  [CASH_DEPOSIT_CASH_TYPE.TEN_DOLLAR]: {
    label: '$10 bills',
    icon: ten_dollar_icon,
    value: 10,
  },
  [CASH_DEPOSIT_CASH_TYPE.TWENTY_DOLLAR]: {
    label: '$20 bills',
    icon: twenty_dollar_icon,
    value: 20,
  },
  [CASH_DEPOSIT_CASH_TYPE.FIFTY_DOLLAR]: {
    label: '$50 bills',
    icon: fifty_dollar_icon,
    value: 50,
  },
  [CASH_DEPOSIT_CASH_TYPE.ONE_HUNDRED]: {
    label: '$100 bills',
    icon: one_hundred_dollar_icon,
    value: 100,
  },
};

// @ts-ignore
export const cashDepositInitialValues: Record<CASH_DEPOSIT_CASH_TYPE, ICashDepositItem> = {};
Object.entries(configs).map(([key, item]) => {
  const value = ({
    total: 0,
    id: '',
    cashType: key,
    quantity: 0,
    value: (item as any)?.value,
  });
  set(cashDepositInitialValues, key, value);
});

export const cashDepositConfigs = configs;
type Props = {
  type: CASH_DEPOSIT_CASH_TYPE;
  value?: ICashDepositItem;
  form: FormInstance<any>;
  onFocus: () => void;
  inputRef?: React.RefObject<InputRef>;
  disabled?: boolean;
};
const CashTypeItem = ({ type, value, onFocus, inputRef, disabled }: Props) => {
  const config = get(configs, type);
  if (!config) return null;
  return (
    <Container disabled={disabled}>
      <Image>
        <img src={config.icon} alt={config.label} />
      </Image>
      <Label>{config.label}</Label>
      <Form.Item noStyle name={[type, 'quantity']}>
        <InputNumber inputRef={inputRef as any} onFocus={onFocus} />
      </Form.Item>
      <Form.Item noStyle name={[type, 'total']} />
      <Form.Item noStyle name={[type, 'id']} />
      <Form.Item noStyle name={[type, 'cashType']} />
      <Form.Item noStyle name={[type, 'value']} />
      <Info>
        <PassValueForm name={[type, 'quantity']} render={(quantity) =>
          <Total>{formatCurrency(quantity * (value?.value || 0))}</Total>
        } />
      </Info>
    </Container>
  );
};

export default CashTypeItem;

const Label = styled.p`
  color: #2D6772;
  text-align: right;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
`;
const Total = styled.p`
  color: #505050;
  text-align: right;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;


const Info = styled.div`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-top: 1px solid #CCD4DC;
  background: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
`;

const InputNumber = styled(CashierInputNumber)`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: center;
  border-radius: 4px;
  border: 1px solid #86909C;
  background: #FFF;
  width: 120px;
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  padding-top: 8px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  background: #F6F7FC;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
  ${({ disabled }) => disabled && css`
    pointer-events: none;
  `}
`;

const Image = styled.div`
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  img {
    height: auto;
    width: 120px;
    align-self: stretch;
  }
`;